@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.template

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.template.TemplateModel
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import kotlinx.coroutines.flow.Flow

actual class GetListTemplateUseCaseImpl actual constructor(val templateRepository: TemplateRepository) :
    GetListTemplateUseCase {
    actual override operator fun invoke(
        page: Int,
        pageSize: Int,
        isRefreshData: Boolean
    ): Flow<FlowResult<TemplateModel>> {
        return templateRepository.getTemplates(page, pageSize)
    }
}
